import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

function Classifieds() {
  const [classifiedData, setClassifiedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const classifiedsPerPage = 12;

  useEffect(() => {
    const fetchClassifieds = async () => {
      try {
        const response = await axios.get('https://backend-zkgn.onrender.com/api/classified');
        setClassifiedData(response.data); // Assume data is an array of objects with classified_id, classified_name, isActive
      } catch (error) {
        console.error('Error fetching classifieds:', error);
      }
    };

    fetchClassifieds();
  }, []);

  // Pagination logic
  const indexOfLast = currentPage * classifiedsPerPage;
  const indexOfFirst = indexOfLast - classifiedsPerPage;
  const currentClassifieds = classifiedData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(classifiedData.length / classifiedsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this classified?")) {
      try {
        await axios.delete(`https://backend-zkgn.onrender.com/api/classified/${id}`);
        setClassifiedData((prevData) => prevData.filter((item) => item.classified_id !== id));
      } catch (error) {
        console.error('Error deleting classified:', error);
        alert('Failed to delete. Try again.');
      }
    }
  };

  return (
    <div className="container-fluid my-4">
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h5 className="fw-bold text-tertiary mb-2">
          <strong>{classifiedData.length}</strong> - Classifieds Found
        </h5>
        <Link to="/addclassified" className="btn btn-primary">
          Add New Classified
        </Link>
      </div>

      <div className="row">
        {currentClassifieds.map((item) => (
          <div className="col-6 col-sm-6 col-md-4 col-lg-3 mb-4" key={item.classified_id}>
            <div className="classified-card position-relative shadow-sm p-3 rounded">
              <div className="classified-name fw-bold">{item.classified_name}</div>

              <div className="position-absolute bottom-0 end-0 p-2 d-flex">
                <Link to={`/editclassified/${item.classified_name.replace(
                    /\s+/g,
                    "-"
                  )}/${item.classified_id}`} className="btn btn-link text-success p-0 me-3">
                  <i className="fa fa-edit"></i>
                </Link>
                <button onClick={() => handleDelete(item.classified_id)} className="btn btn-link text-danger p-0">
                  <i className="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="pagination-container">
        <button className="pagination-btn" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
          Previous
        </button>
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i + 1}
            className={`pagination-btn ${currentPage === i + 1 ? 'active' : ''}`}
            onClick={() => handlePageChange(i + 1)}
          >
            {i + 1}
          </button>
        ))}
        <button className="pagination-btn" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
          Next
        </button>
      </div>
    </div>
  );
}

export default Classifieds;
